import { ServiceEdit } from './edit'
import Saas from 'saas/react-admin/resources'

export default class Service {
  static Edit = ServiceEdit
  static List = Saas.Service.List
  static Icon = Saas.Service.Icon
}
